import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/index'),
  },
  {
    path: '/learn',
    name: 'learn',
    component: () => import('@/views/learn'),
  }
]

const router = new VueRouter({
  routes
})

export default router
